import { memo } from 'react';
import { useTranslation } from '@aimsos/i18n';
import { SelectableChip } from '@aimsos/ui';

import { INSIGHT_QUICK_FILTERS } from '../../constants/intelligence.js';

/**
 * The Insights chips: All, Channel, Timing, How they decide, Deal outlook,
 * Scheduling (CT-5716). Toggle buttons (`aria-pressed`); exactly one is on.
 */
const InsightQuickFilters = memo(function InsightQuickFilters({ value, onChange, disabled = false }) {
  const { t } = useTranslation('unified-profiles');

  return (
    <div
      role="group"
      aria-label={t('intelligence.insights.quickFilters.ariaLabel')}
      data-testid="insight-quick-filters"
      className="flex flex-wrap items-center gap-2"
    >
      {INSIGHT_QUICK_FILTERS.map((id) => (
        <SelectableChip
          key={id}
          size="m"
          selected={value === id}
          disabled={disabled}
          // One handler per chip: the id is the payload, so no event round-trip.
          onClick={() => onChange(id)}
        >
          {t(`intelligence.insights.quickFilters.${id}`)}
        </SelectableChip>
      ))}
    </div>
  );
});

export default InsightQuickFilters;
